import { produce } from 'immer';

import { PdfAction } from '@app/libs/reactPdfJs/store/actions';
import {
  EDITING_DOCUMENT__FIELD_CREATE,
  EDITING_DOCUMENT__FIELD_SIZE_CHANGE,
  PDF_CLEAR_ALL_STATE,
} from '@app/store/actionTypes';
import { EditingDocumentAction } from '@app/store/editingDocument/actions';

export interface EditingDocumentSizesState {
  [id: string]: {
    currentScaleHeight: number;
    currentScaleWidth: number;
    height: number;
    relativeHeight: number;
    relativeWidth: number;
    width: number;
  };
}

const initialState: EditingDocumentSizesState = {};

export default function reducer(
  state: EditingDocumentSizesState = initialState,
  action: EditingDocumentAction | PdfAction
) {
  switch (action.type) {
    case EDITING_DOCUMENT__FIELD_CREATE:
      return produce(state, (draft) => {
        const { currentScaleHeight, currentScaleWidth, height, uuid, width } = action.payload.meta;
        draft[uuid] = {
          currentScaleHeight,
          currentScaleWidth,
          height,
          relativeHeight: currentScaleHeight,
          relativeWidth: currentScaleWidth,
          width,
        };
      });
    case EDITING_DOCUMENT__FIELD_SIZE_CHANGE:
      return produce(state, (draft) => {
        const { currentScaleHeight, currentScaleWidth, relativeHeight, relativeWidth, uuid } =
          action.payload;
        draft[uuid].currentScaleHeight = currentScaleHeight;
        draft[uuid].currentScaleWidth = currentScaleWidth;
        draft[uuid].relativeHeight = relativeHeight;
        draft[uuid].relativeWidth = relativeWidth;
      });
    case PDF_CLEAR_ALL_STATE:
      return initialState;
    default:
      return state;
  }
}
